var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContainerPage",
    { attrs: { title: "Configuración Cámaras" } },
    [
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "align-end": "",
                "justify-end": "",
                row: "",
                "fill-height": ""
              }
            },
            [
              _c("v-flex", { attrs: { md1: "" } }, [
                _c(
                  "div",
                  [
                    _vm.dataGrid
                      ? _c("ClasificacionPatenteModal", {
                          ref: "clasificacionPatenteModal",
                          attrs: {
                            dataGrid: _vm.dataGrid,
                            triggerDialogOpen: _vm.triggerDialogOpen,
                            isConfiguration: true
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "", sm5: "", md3: "" } }),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm5: "",
                    md3: "",
                    "offset-xs0": "",
                    "offset-lg6": ""
                  }
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar...",
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { md12: "", grow: "", "pa-1": "" } },
                [
                  _c("ClasificacionPatenteTable", {
                    attrs: {
                      isClasificated: _vm.whitSchema,
                      config: _vm.configTable,
                      dataTable: _vm.dataTable,
                      search: _vm.search,
                      isConfiguration: true
                    },
                    on: { clasificate: _vm.clasificate }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }